export var ApplicableLawState;
(function (ApplicableLawState) {
    ApplicableLawState["EXCELLENT"] = "excellent";
    ApplicableLawState["MEETING_REQUIREMENTS"] = "meetingRequirements";
    ApplicableLawState["RISKY"] = "risky";
})(ApplicableLawState || (ApplicableLawState = {}));
//# sourceMappingURL=types.js.map